import { KOALA, GREAT_WHITE } from 'HubStyleTokens/colors';
import styled, { keyframes } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const pulse = keyframes(["0%{background-color:", "}50%{background-color:", "}100%{background-color:", "}"], KOALA, GREAT_WHITE, KOALA);
const SkeletonBase = styled.div.withConfig({
  displayName: "FileSkeleton__SkeletonBase",
  componentId: "sc-1mz89en-0"
})(["display:inline-block;height:34px;width:100%;border-radius:3px;margin-top:4px;margin-bottom:0px;animation:", " 2s ease-in-out infinite;"], pulse);
const FileSkeleton = () => /*#__PURE__*/_jsx(SkeletonBase, {
  "data-test-id": "file-skeleton"
});
export default FileSkeleton;